import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { NavButton } from "@repo/ui/nav-button";
import type { FloatingNavItem } from "./floating-nav.types";
import { Icon } from "@repo/ui/icon";
interface MobileNavSheetProps {
  headline?: string;
  items: FloatingNavItem[];
  activeId: string | null;
  onClose: () => void;
  onNavClick: (targetId: string) => void;
  onScrollToTop: () => void;
}

/**
 * Mobile expanded bottom sheet.
 * Full-width panel anchored to bottom with nav items listed vertically.
 */
export function MobileNavSheet(t0) {
  const $ = _c(28);
  const {
    headline,
    items,
    activeId,
    onClose,
    onNavClick,
    onScrollToTop
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("w-full", "bg-grey-50/95 backdrop-blur-[5px]", "rounded-t-sm", "border border-border-subtle", "shadow-sm");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = headline || "Jump to";
  let t3;
  if ($[1] !== t2) {
    t3 = <span className="typography-component-sm-medium text-text-primary">{t2}</span>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon name="close" size="lg" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onClose) {
    t5 = <button type="button" onClick={onClose} className="flex h-6 w-6 items-center justify-center text-text-primary" aria-label="Close navigation menu">{t4}</button>;
    $[4] = onClose;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <div className="flex items-center justify-between py-3">{t3}{t5}</div>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="h-px w-full bg-border-subtle" aria-hidden="true" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== activeId || $[11] !== items || $[12] !== onNavClick) {
    let t9;
    if ($[14] !== activeId || $[15] !== onNavClick) {
      t9 = item => <NavButton key={item.targetId} variant="item" active={item.targetId === activeId} onClick={() => onNavClick(item.targetId)} className="self-start gap-2">{item.targetId === activeId && <Icon name="arrow-right" size="lg" />}{item.label}</NavButton>;
      $[14] = activeId;
      $[15] = onNavClick;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    t8 = items.map(t9);
    $[10] = activeId;
    $[11] = items;
    $[12] = onNavClick;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="h-px w-full bg-border-subtle" aria-hidden="true" />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== onClose || $[19] !== onScrollToTop) {
    t10 = () => {
      onScrollToTop();
      onClose();
    };
    $[18] = onClose;
    $[19] = onScrollToTop;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = cn("typography-component-sm-medium", "flex self-start items-center gap-2 rounded-full py-3", "text-text-primary transition-colors", "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-open-water-500");
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10) {
    t12 = <button type="button" onClick={t10} className={t11}>Back to top</button>;
    $[22] = t10;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t6 || $[26] !== t8) {
    t13 = <div className={t1}><div className="flex flex-col gap-3 px-4 pb-8 pt-2">{t6}{t7}{t8}{t9}{t12}</div></div>;
    $[24] = t12;
    $[25] = t6;
    $[26] = t8;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}